import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { Progress, Tooltip, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import FD from '../../../RestAPI/fetchData';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import App_data from '../../../config/App_data';
import language from '../../../../assets/languages/language';
import Loader from '../../../../common/loader';
import AppRoutes from '../../../config/AppRoutes';
import { Y_AXIS_SCALES } from '../../../../common/constant';
import { renderHTMLContent, renderSanitizedHTML } from '../../../../common/function';
import EmailResubscribe from '../../../../components/EmailResubscribe';

let iterator = '';
/* eslint-disable*/

class SOA_P_Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      reportAnswerStatus: false,
      reportEditStatus: false,
      reportEditId: '',
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      items_val: '',
      item_status: '',
      dropdownOpen: false,
      ValidToken: false,
      token: '',
      idname: '',
      notesFlashReport: [],
      flashreport: [], //All Flash question Store
      savedquestion: [],
      savednotes: [],
      progress_bar_zero: [],
      progress_bar: [],
      progress_bar_slider: [],
      main_bargraph_data: '',
      bar_chapter: '',
      bar_main_user: [],
      bar_main_class: [],
      reportquestion: [],
      reportnotes: [],
      startDate: '',
      startDate_second: '',
      send_startDate: '',
      send_startDate_second: '',

      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,

      more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      show_outer: 'hide_block',
      chapters: '',
      subreadings_status: false,
      display_main_loader: 'show_block',
      display_loader: 'hide_block',
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
      ErrorMessage: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      type: '',
      activeTabFlashcards: '1',
      activeTabSaved: '1',
      activeTabReports: '1',
      tooltips: [
        {
          placement: `${language.LC().SEPARATE_YOUR_RESULT}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().YOU_CAN_SEE}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().THAT_SPECIFIC_NOTES}`,
          text_align: 'left',
        },
      ],
      qpLoader: true,
      npLoader: true,
      savedLoader: true,
      flashLoader: true,
      reportLoader: true,
      savedVideos: [],
      reportedVideos: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
    this.toggleDone = this.toggleDone.bind(this);

    this.toggleCloseReport = this.toggleCloseReport.bind(this);
    this.toggleAlertReport = this.toggleAlertReport.bind(this);

    this.CloseEditQuesReport = this.CloseEditQuesReport.bind(this);
    this.OpenEditQuesReport = this.OpenEditQuesReport.bind(this);

    this.CloseEditNotesReport = this.CloseEditNotesReport.bind(this);
    this.OpenEditNotesReport = this.OpenEditNotesReport.bind(this);
    this.onContactChange = this.onContactChange.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    FD.callAPI(App_data.backend_api + '/user/authtoken', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/getChapters', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, chapters: resp.chapters });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/soa_p_dashboard/mainProgressbar', data).then(resp => {
      if (resp.success) {
        this.setState({ display_loader: 'hide_block' });
        var dataString = JSON.stringify(resp.chapters);
        var dataReason = JSON.parse(dataString);
        var final_array_main = [];
        for (iterator = 0; iterator < dataReason.length; iterator++) {
          var right_answered = dataReason[iterator].answered_count;
          /* var total_question=dataReason[i].question_stat_count;*/
          var total_question = dataReason[iterator].attempted_count;
          var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

          if (user_graph_val === 'NaN') {
            final_array_main.push('0.0');
          } else {
            final_array_main.push(user_graph_val);
          }
        }

        this.setState({ bar_main_user: final_array_main });
      } else {
        this.setState({ display_loader: 'hide_block' });
        // console.log(resp.success+'------------failure');
      }
    });
    this.setState({ display_main_loader: 'show_block' });
    FD.callAPI(App_data.backend_api + '/soa_p_dashboard/mainProgressclassbar', data).then(resp => {
      if (resp.success) {
        this.setState({ display_main_loader: 'hide_block' });
        var dataString = JSON.stringify(resp.chaptersclass);
        var dataReason = JSON.parse(dataString);

        var final_array_main = [];

        for (iterator = 0; iterator < dataReason.length; iterator++) {
          var right_answered = dataReason[iterator].answered_count;
          var total_question = dataReason[iterator].attempted_count;
          var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

          if (user_graph_val === 'NaN') {
            final_array_main.push('0.0');
          } else {
            final_array_main.push(user_graph_val);
          }
        }
        this.setState({ bar_main_class: final_array_main });
      } else {
        this.setState({ display_loader: 'hide_block' });
        // console.log(resp.success+'------------failure');
      }
    });
    FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getQuestionProgByUser', data).then(resp => {
      if (resp.success) {
        this.setState({
          progress_bar_zero: resp.progressbarzero_data,
          qpLoader: false,
        });
      } else {
        //console.log(resp.success + "------------failure");
      }
    });
    FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getNotesChapter', data).then(resp => {
      if (resp.success) {
        //this.setState({progress_bar:resp.chapters});
        this.setState({ bar_chapter: resp.chapters });
      } else {
        //console.log(resp.success + "------------failure");
      }
    });
    await this.getQuestionFlashCards();
    await this.getNotesFlashCards();

    await this.getQuestionSaved();
    await this.getNotesSaved();

    FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getnotesprogByuser', data).then(resp => {
      if (resp.success) {
        this.setState({ progress_bar: resp.progressbar_data, npLoader: false });
      } else {
        //console.log(resp.success + "------------failure");
      }
    });

    await this.getQuestionReports();
    await this.getNotesReports();

    await this.getVideoReports();
    await this.getVideosSaved();
  }

  /*
   * get saved all video
   */
  getVideosSaved = async () => {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_videos/getFavVideosbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ savedVideos: resp.soa_p_videos });
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );
  };

  // function for get  video report
  getVideoReports = async () => {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    console.log('I am heree');
    await FD.callAPI(App_data.backend_api + '/soa_p_videos/getReportsVideobyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ reportedVideos: resp.video });
          console.log('resp.video', resp.video);
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );
  };

  /*
  ---------------------------------------
    Function to get  question report
  ---------------------------------------
  */
  getQuestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    console.log('I am heree');

    await FD.callAPI(
      App_data.backend_api + '/soa_p_question_bank/getReportsQuestionsbyuserid',
      data,
    ).then(async resp => {
      if (resp.success) {
        this.setState({ reportquestion: resp.questions, reportLoader: false });
      } else {
        //console.log(resp.success + "------------failure");
      }
    });
  };

  /*
  ---------------------------------------
    Function to get  question flash card
  ---------------------------------------
  */
  getQuestionFlashCards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/soa_p_question_bank/getFlashcardsbyuserid',
      data,
    ).then(resp => {
      if (resp.success) {
        this.setState({ flashreport: resp.flash_report, flashLoader: false });
      } else {
        //console.log(resp.success + "------------failure");
      }
    });
  };

  /*
  ------------------------------------
    Function to get  question saved
  -------------------------------------
  */
  getQuestionSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/soa_p_question_bank/getFavQuestionsbyuserid',
      data,
    ).then(resp => {
      if (resp.success) {
        this.setState({ savedquestion: resp.questions, savedLoader: false });
      } else {
        //console.log(resp.success + "------------failure");
      }
    });
  };

  /*
  -----------------------------------
      Function to get  notes report
  -----------------------------------
  */
  getNotesReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_notes/getReportsNotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ reportnotes: resp.notes });
        } else {
          //console.log(resp.success + "------------failure");
        }
      },
    );
  };

  /*
  ----------------------------------------
      Function to get  notes flash card
  --------------------------------------
  */
  getNotesFlashCards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_notes/getFlashcardsnotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ notesFlashReport: resp.flash_report });
        } else {
          //console.log(resp.success + "------------failure");
        }
      },
    );
  };

  /*
  ---------------------------------
    Function to get  notes Saved 
  ---------------------------------
  */
  getNotesSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_notes/getFavNotesbyuserID', data).then(
      async resp => {
        if (resp.success) {
          this.setState({ savednotes: resp.soa_p_fav_notes });
        } else {
          //console.log(resp.success + "------------failure");
        }
      },
    );
  };

  OpenEditQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      quesReport: item.comment,
      type: 'quesReport',
    });
  }

  OpenEditNotesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      notesReport: item.comment,
      type: 'notesReport',
    });
  }

  CloseEditQuesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      quesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditNotesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      notesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  toggleAlertReport(item, data, e) {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: item.id,
      type: data,
    });
  }

  toggleCloseReport() {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      contactStatus: false,
    });
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      items_val: '',
      item_status: '',
    });
  }

  OpenEditVideoReport = item => {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      videoReport: item.comment,
      type: 'videoReport',
    });
  };

  handleVideoReportSubmit = async event => {
    event.preventDefault();
    if (this.state.videoReport === '' && this.state.videoReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, videoReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      videoReport: videoReport,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_videos/UpdateReportsVideobyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            videoReport: '',
          });
          await this.getVideoReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  deleteFlashCard = async (type, id) => {
    const { idname: id_name, token } = this.state;
    const payload = {
      id_name,
      token,
      type: type,
      question_type: '',
      exam: 'soa_p',
      level: '',
      item_id: id,
    };
    await FD.callAPI(`${App_data.backend_api}/question_bank_2024/deleteFlashCard`, payload);
  };

  async toggleDone() {
    const { idname, token, item_status, items_val } = this.state;
    const { question_id, item_id, video_id } = items_val;
    if (this.state.item_status === 'flashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(App_data.backend_api + '/soa_p_question_bank/deleteFlashCard', data).then(
        async resp => {
          if (resp.success) {
            await this.getQuestionFlashCards();
          } else {
            //console.log("error");
          }
        },
      );
    }
    if (this.state.item_status === 'Notesflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };

      await FD.callAPI(App_data.backend_api + '/soa_p_notes/deleteDashboardFlashCard', data).then(
        async resp => {
          if (resp.success) {
            await this.getNotesFlashCards();
          } else {
            //console.log("error");
          }
        },
      );
    }
    if (item_status === 'savedquestion') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      this.deleteFlashCard('question', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/soa_p_question_bank/deleteSavequestion', data).then(
        async resp => {
          if (resp.success) {
            await this.getQuestionSaved();
          } else {
            //console.log("error");
          }
        },
      );
    }

    if (item_status === 'Savednotes') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      this.deleteFlashCard('notes', question_id ? question_id : item_id);
      await FD.callAPI(App_data.backend_api + '/soa_p_notes/deleteSaveNotes', data).then(
        async resp => {
          if (resp.success) {
            await this.getNotesSaved();
          } else {
            //console.log("error");
          }
        },
      );
    }

    if (this.state.item_status == 'Reportsquestion') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/soa_p_question_bank/deleteDashboardQuestionReports',
        data,
      ).then(async resp => {
        if (resp.success) {
          await this.getQuestionReports();
        } else {
          //console.log("error");
        }
      });
    }

    if (this.state.item_status == 'Reportsnotes') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/soa_p_notes/deleteDashboardNotesReports',
        data,
      ).then(async resp => {
        if (resp.success) {
          await this.getNotesReports();
        } else {
          //console.log("error");
        }
      });
    }
    /*
    -----------------------------------
     API for delete the saved video
    -----------------------------------
     */
    if (item_status == 'savedvideos') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      this.deleteFlashCard('video', video_id ? video_id : item_id);
      await FD.callAPI(App_data.backend_api + '/soa_p_videos/deleteSaveVideo', data).then(
        async resp => {
          if (resp.success) {
            await this.getVideosSaved();
          } else {
            // console.log("error");
          }
        },
      );
    }

    /*
    -----------------------------------
     API for delete the video reports
    -----------------------------------
     */
    if (this.state.item_status == 'Reportsvideos') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/soa_p_videos/deleteDashboardVideoReports',
        data,
      ).then(async resp => {
        if (resp.success) {
          await this.getVideoReports();
        } else {
          console.log('error');
        }
      });
    }

    this.setState({
      alert_status: false,
    });
  }

  onContactChange(data, index, type) {
    //console.log("dfaay", data);
    if (!this.state.contactStatus) {
      this.setState({
        contactID: data.id,
        contactType: type,
        contactIndex: index,
        contactStatus: true,
      });
    } else {
      this.setState({
        contactID: '',
        contactType: '',
        contactIndex: '',
        contactSubject: '',
        contactComment: '',
        SubjectErrorMessage: '',
        CommentErrorMessage: '',
        contactStatus: false,
      });
    }
  }

  onContactSubmit = async event => {
    event.preventDefault();
    if (this.state.contactSubject === '' && this.state.contactSubject.length < 1) {
      this.setState({
        displaytext: 'show_block',
        SubjectErrorMessage: "Subject can't be empty",
        isLoading: false,
      });
      return;
    }
    if (this.state.contactComment === '' && this.state.contactComment.length < 1) {
      this.setState({
        displaytext: 'show_block',
        CommentErrorMessage: "Comment can't be empty",
        isLoading: false,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    const { idname, token, contactComment, contactSubject } = this.state;
    const data = {
      idname: idname,
      token: token,
      contactComment: contactComment,
      contactSubject: contactSubject,
    };
    await FD.callAPI(App_data.backend_api + '/contact_us/sendReportHelpRequest', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            isLoading: false,
            successAlert: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = e => {
    this.setState({
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
    });
  };

  handleChange(date) {
    this.setState({
      startDate: date,
      startDate_second: '',
      send_startDate: moment(date).format('YYYY-MM-DD'),
      subreadings_status: false,
    });
  }

  handleChange_second(date) {
    if (this.state.startDate !== '') {
      // document.getElementById('outer_readings_id').innerHTML = '';
      this.setState(
        {
          startDate_second: date,
          send_startDate_second: moment(date).format('YYYY-MM-DD'),
          subreadings_status: true,
          display_main_loader: 'show_block',
        },
        function afterdateChange() {
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            startDate: this.state.send_startDate,
            endDate: this.state.send_startDate_second,
          };
          FD.callAPI(App_data.backend_api + '/soa_p_dashboard/mainProgressbar', data).then(resp => {
            if (resp.success) {
              var dataString = JSON.stringify(resp.chapters);
              var dataReason = JSON.parse(dataString);

              var final_array_main = [];

              for (iterator = 0; iterator < dataReason.length; iterator++) {
                var right_answered = dataReason[iterator].answered_count;
                /* var total_question=dataReason[i].question_stat_count;*/
                var total_question = dataReason[iterator].attempted_count;

                var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }

                ////console.log(final_array_main+'----fdg-------');
              }

              this.setState({
                bar_main_user: final_array_main,
                display_main_loader: 'hide_block',
              });
              // console.log('***********'+this.state.bar_main_user+'++++++++++++');
            } else {
              this.setState({
                display_main_loader: 'hide_block',
              });
              //console.log(resp.success + "------------failure");
            }
          });
          FD.callAPI(App_data.backend_api + '/soa_p_dashboard/mainProgressclassbar', data).then(
            resp => {
              if (resp.success) {
                var dataString = JSON.stringify(resp.chaptersclass);
                var dataReason = JSON.parse(dataString);
                var final_array_main = [];
                for (iterator = 0; iterator < dataReason.length; iterator++) {
                  var right_answered = dataReason[iterator].answered_count;
                  var total_question = dataReason[iterator].attempted_count;
                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ bar_main_class: final_array_main });
                //console.log('***********'+this.state.bar_main_class+'++++++++++++');
              } else {
                //console.log(resp.success + "------------failure");
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getProgressChapter', data).then(
            resp => {
              if (resp.success) {
                this.setState({ progress_bar_zero: resp.chapters });
              } else {
                //console.log(resp.success + "------------failure");
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getQuestionProgByUser', data).then(
            resp => {
              if (resp.success) {
                this.setState({
                  progress_bar_zero: resp.progressbarzero_data,
                  qpLoader: false,
                });
              } else {
                //console.log(resp.success + "------------failure");
              }
            },
          );

          FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getNotesChapter', data).then(resp => {
            if (resp.success) {
              //this.setState({progress_bar:resp.chapters});
              this.setState({ bar_chapter: resp.chapters });
            } else {
              //console.log(resp.success + "------------failure");
            }
          });

          FD.callAPI(App_data.backend_api + '/soa_p_dashboard/getnotesprogByuser', data).then(
            resp => {
              if (resp.success) {
                this.setState({
                  progress_bar: resp.progressbar_data,
                  npLoader: false,
                });
              } else {
                //console.log(resp.success + "------------failure");
              }
            },
          );
        },
      );
    }
  }

  _deleteFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('flashcard');
  };

  _deleteNotesFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Notesflashcard');
  };

  _deleteSavequestino = items => {
    this.setState({ items_val: items });
    this.toggleAlert('savedquestion');
  };

  _deleteReportsquestino = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsquestion');
  };

  _deleteSavedNotes = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Savednotes');
  };

  _deleteReportsNotes = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsnotes');
  };

  _getall = () => {
    if (this.state.show_outer === 'hide_block') {
      this.setState({ show_outer: 'show_block' });
      this.setState({ more_detail_button: 'Hide Details' });
    }
    if (this.state.show_outer === 'show_block') {
      this.setState({ show_outer: 'hide_block' });
      this.setState({ more_detail_button: 'I Want More Details' });
    }
  };

  _beginChapter = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    FD.callAPI(App_data.backend_api + '/soa_p_question_bank/getQuestionsbyid', data).then(resp => {
      if (resp.success) {
        this.context.router.push({
          pathname: `/soa/probability/beginchapter/${resp.questionsbyid.chapter_id}/${resp.questionsbyid.reading_id
            }/${item.question_id}/${resp.questionsbyid.chapter_id}`,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            reading: resp.questionsbyid.reading_id,
            chapter: resp.questionsbyid.chapter_id,
          },
        });
      } else {
        //console.log("Not Found");
      }
    });
  };

  /*
  --------------------------------------------------
    Function to redirect page on specifc questions 
  --------------------------------------------------
  */
  _beginNotes = async (reading, e) => {
    var reading_id = '';
    var chapter_id = '';
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.question_id,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_notes/getNotesByID', data).then(resp => {
      if (resp.success) {
        chapter_id = resp.notes[0].chapter_id;
        reading_id = resp.notes[0].reading_id;

        this.context.router.push({
          pathname:
            '/soa/probability/beginnotes/' +
            chapter_id +
            '/' +
            reading_id +
            '/' +
            reading.question_id +
            '/' +
            0,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            reading: reading_id,
            chapter: chapter_id,
            offset: 0,
          },
        });
      }
    });
  };

  questionProgressBarFun() {
    return this.state.progress_bar_zero.map((item, index) => {
      var progressnotes_zero = Math.round((item.counttotquestion / item.question_stat_count) * 100);
      if (progressnotes_zero < 1) {
        progressnotes_zero = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>Q.{item.chapter_id}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes_zero}
                      style={{ width: progressnotes_zero + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  notesProgressBarFun() {
    return this.state.progress_bar.map((item, index) => {
      var progresstotalques = item.chapterallqurestion;
      var progressnotes = Math.round((item.fav / progresstotalques) * 100);
      if (progressnotes < 1) {
        progressnotes = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>N.{item.chapter_id}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes}
                      style={{ width: progressnotes + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  _beginVideos = async (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.video_id,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_videos/getVideoByID', data).then(resp => {
      if (resp.success) {
        let index = resp.allVideo.findIndex(item => item.id === resp.video[0].id);
        const { id, chapter_id } = resp.video[0];
        this.context.router.push({
          pathname: AppRoutes.SOA_PROBABILITY_VIDEO_DISPLAY.replace(':id', id)
            .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
            .replace(':chapterId', chapter_id)
            .replace(':index', index),
        });
      }
    });
  };

  /*
  ---------------------------------
    question form submit function
  ----------------------------------
  */
  async handleQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.quesReport === '' && this.state.quesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, quesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: quesReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/soa_p_question_bank/UpdateReportsQuestionsbyuserid',
      data,
    ).then(async resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          quesReport: '',
        });
        await this.getQuestionReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  /*
  ---------------------------------
    notes form submit function
  ----------------------------------
  */
  async handleNotesReportSubmit(event) {
    event.preventDefault();
    if (this.state.notesReport === '' && this.state.notesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, notesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      notesReport: notesReport,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_notes/UpdateReportsNotesbyuserid', data).then(
      async resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            reportEditStatus: !this.state.reportEditStatus,
            reportEditId: '',
            notesReport: '',
          });
          await this.getNotesReports();
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  /*
  -------------------------------------------------------
    function for state change of edit report form fileds
  -------------------------------------------------------
  */
  InputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      ErrorMessage: '',
    });
  }

  /*
  -------------------------------------------------------
    function for state change of edit report form fileds
  -------------------------------------------------------
  */
  SubjectInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      SubjectErrorMessage: '',
    });
  }

  /*
  -------------------------------------------------------
    function for state change of edit report form fileds
  -------------------------------------------------------
  */
  CommentInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      CommentErrorMessage: '',
    });
  }

  flashcardTabToggle = tab => {
    if (this.state.activeTabFlashcards !== tab) {
      this.setState({
        activeTabFlashcards: tab,
      });
    }
  };

  savedTabToggle = tab => {
    if (this.state.activeTabSaved !== tab) {
      this.setState({
        activeTabSaved: tab,
      });
    }
  };

  reportsTabToggle = tab => {
    if (this.state.activeTabReports !== tab) {
      this.setState({
        activeTabReports: tab,
      });
    }
  };

  _deleteReportsVideo = items => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsvideos');
  };

  _deleteSavedVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savedvideos');
  };

  render() {
    const {
      activeTabFlashcards,
      activeTabSaved,
      activeTabReports,
      qpLoader,
      npLoader,
      savedLoader,
      flashLoader,
      reportLoader,
      savedVideos,
      reportedVideos,
    } = this.state;
    let flashreport_val = this.state.flashreport;
    let notes_flashreport_val = this.state.notesFlashReport;
    let savedquestion_val = this.state.savedquestion;
    let savednotes_val = this.state.savednotes;

    let reportquestion_val = this.state.reportquestion;
    let reportnotes_val = this.state.reportnotes;

    // let progress_bar_zero_val = this.state.progress_bar_zero;
    // let progress_barnotes_val = this.state.progress_bar;
    let flashcard_data = '';
    let notes_flashcard_data = '';
    let savedquestion_data = '';
    let savednotes_data = '';

    let question_reportsData = ''; // for question reports
    let notes_reportsData = '';
    let reportedVideosDataDisplay = '';
    let savedVideoDataDisplay = '';
    // let progress_bar_data = "";
    // let token_Val = this.state.token;
    // let idname_Val = this.state.idname;
    /*first main graph*/
    let main_bar_val = this.state.bar_chapter;
    let main_bar_percentage = this.state.bar_main_user;

    let main_bar_user_percentage = this.state.bar_main_class;
    let main_bar_data = [];
    var i = 0;

    Object.keys(main_bar_val).map(function (key) {
      var dataString = JSON.stringify(main_bar_val[key]);
      var dataReason = JSON.parse(dataString);
      main_bar_data[i] = dataReason.chapter_name.substring(0, 14);
      var chapter_id = dataReason.chapter_id;

      i++;
    });

    var bar_data = {
      labels: main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31, 140, 235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31, 140, 235)',
          data: main_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_bar_user_percentage,
        },
      ],
    };

    /*other graph*/
    let chapters = this.state.chapters;
    let reading_data = '';

    if (this.state.chapters.length && !this.state.subreadings_status) {
      reading_data = chapters.map((item, index) => (
        <div className='card' key={index}>
          <div className='card-header' key={item.id} value={item.id}>
            <a className='pointer_class' id={item.chapter_name} value={item.id}>
              {item.chapter_name}
            </a>
          </div>
          <div className='card-block' key={item.chapter_name} id={'bar_sub_item' + index}>
            {/*<Barget chapter_id={item.chapter_no} idname={this.state.idname} token={this.state.token} answered_state={index} />*/}
          </div>
        </div>
      ));
    }
    if (this.state.chapters.length && this.state.subreadings_status) {
      reading_data = chapters.map((item, index) => (
        <div className='col-sm-12' key={index}>
          <div className='card ' key={item.id}>
            <div className='card-header' key={item.id} value={item.id}>
              <a className='pointer_class' id={item.chapter_name} value={item.id}>
                {item.chapter_name}
              </a>
            </div>
            <div className='card-block' key={item.chapter_name} id={'bar_sub_item' + index}>
              {/*<Barget chapter_id={item.chapter_no} idname={this.state.idname} token={this.state.token} answered_state={index} startDate={this.state.send_startDate} endDate={this.state.send_startDate_second} subreadings_status={this.state.subreadings_status}/>*/}
            </div>
          </div>
        </div>
      ));
    }

    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'flash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong>{language.LC().Saved_Note}: </strong> {items.flash_card}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
 <button className="btn btn-primary" onClick={this._deleteFlashcard.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (flashLoader) {
      flashcard_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.notesFlashReport.length) {
      notes_flashcard_data = notes_flashreport_val.map((items, index) => (
        <div id={'notesFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteNotesFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, "span")}
          </p>
        </div>
      ));
    } else {
      notes_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.savedquestion.length) {
      savedquestion_data = savedquestion_val.map((items, index) => (
        <div id={'savedque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong>
              {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={() => this._deleteSavequestino(items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong> {language.LC().TOPIC}: </strong>
                {renderHTMLContent((items.topic_name || '').replace(/LOS \d*/i, ''), "span")}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, "span")}
              </div>
            )}
          </p>

          {/* <button className="btn btn-primary" onClick={this._beginChapter.bind(this,items)}>{language.LC().VIEW}</button>
 <button className="btn btn-primary" onClick={this._deleteSavequestino.bind(this,items)}>{language.LC().DELETE}</button> */}
        </div>
      ));
    } else if (savedLoader) {
      savedquestion_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      savedquestion_data = <div className='text-center'> {language.LC().NO_SAVED_QUESTIONS} </div>;
    }

    if (this.state.savednotes.length) {
      savednotes_data = savednotes_val.map((items, index) => (
        <div id={'savednotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().Notes_ID}: </strong>
              {items.question_id}
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavedNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong> {language.LC().TOPIC}: </strong>
                {renderHTMLContent((items.topic_name || '').replace(/LOS \d*/i, ''), "span")}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, "span")}
              </div>
            )}
          </p>
        </div>
      ));
    } else {
      savednotes_data = <div className='text-center'> {language.LC().NO_SAVED_NOTES} </div>;
    }

    // ===================== Saved Videos Start =========================== //

    if (savedVideos.length > 0) {
      savedVideoDataDisplay = savedVideos.map((items, index) => (
        <div id={'savedvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={() => this._beginVideos(items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={() => this._deleteSavedVideo(items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong> {language.LC().TOPIC}: </strong>
                {renderHTMLContent((items.topic_name || '').replace(/LOS \d*/i, ''), "span")}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, "span")}
              </div>
            )}
          </p>

          {/* <button className="btn_circle_sm" onClick={this._beginChapter.bind(this,items)}><i className="fa fa-eye"></i></button>
            <button className="btn_circle_sm" onClick={this._deleteSavequestino.bind(this,items)}><i className="fa fa-trash" style={{backgroundColor:"red"}}></i></button> */}
        </div>
      ));
    } else {
      savedVideoDataDisplay = <div className='text-center'> {language.LC().NO_SAVED_VIDEO} </div>;
    }
    // ===================== Saved Videos End ============================= //
    if (this.state.reportquestion.length) {
      question_reportsData = reportquestion_val.map((items, index) => (
        <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>

            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditQuesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'quesReport'
              }
              toggle={this.OpenEditQuesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <Button className='close' color='secondary' onClick={this.CloseEditQuesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleQuestionReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id={`comment-${index}`}
                          name='quesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.quesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditQuesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'quesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                />
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'quesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                    this.state.contactType === 'quesReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'quesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'quesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                  this.state.contactType === 'quesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsquestino.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, "span")}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else if (reportLoader) {
      question_reportsData = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      question_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportnotes.length) {
      notes_reportsData = reportnotes_val.map((items, index) => (
        <div id={'reportsnotes_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().Notes_ID}: </strong> {items.question_id}
            </span>

            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditNotesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.OpenEditNotesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <Button className='close' color='secondary' onClick={this.CloseEditNotesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleNotesReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id={`comment-${index}_${items.id}`}
                          name='notesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.notesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditNotesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginNotes.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'notesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'notesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                N. {items.question_id}{' '}
                {renderHTMLContent(items.topic_name, "span")}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                    this.state.contactType === 'notesReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'notesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'notesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                  this.state.contactType === 'notesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsNotes.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, "span")}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      notes_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    // ===================== Report Section Start =================== //
    if (reportedVideos.length) {
      reportedVideosDataDisplay = reportedVideos.map((items, index) => (
        <div id={'reportsvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${items.status === 'resolved' ? 'resolved' : 'pending'
                }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : () => this.OpenEditVideoReport(items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.OpenEditVideoReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id}{renderHTMLContent(items.topic_name, "span")}
                <Button className='close' color='secondary' onClick={this.CloseEditVideoReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={event => this.handleVideoReportSubmit(event)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='videoReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.videoReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditVideoReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'videoReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id}{renderHTMLContent(items.topic_name, "span")}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                    this.state.contactType === 'videoReport' &&
                    this.state.contactID === items.id &&
                    this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{
                      paddingLeft: '0.5rem',
                      paddingTop: '0.5rem',
                    }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                  this.state.contactType === 'videoReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={() => this._deleteReportsVideo(items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, "span")}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      reportedVideosDataDisplay = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }
    // ===================== Report Section End =================== //
    return (
      <div>
        <div className='animated fadeIn'>
          <EmailResubscribe />
          <div className='row'>
            <div className='col-sm-12 margin_bottom_20'>
              <div className='dashboard-top-head-section'>
                <h1 className='section_head'>{language.LC().DASHBOARD}</h1>
              </div>
            </div>

            <div className='col-lg-8'>
              <div className='card margin_bottom_20'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-1 text-md-right align-self-center'>
                      <label className='margin_bottom_0'>{language.LC().FROM}</label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleChange}
                          placeholderText='Select date'
                          width='100%'
                        />
                      </div>
                    </div>
                    <div className='col-sm-1 text-md-center align-self-center'>
                      <label className='margin_bottom_0'> {language.LC().TO} </label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          placeholderText='Select date'
                          width='100%'
                          selected={this.state.startDate_second}
                          minDate={this.state.startDate}
                          onChange={this.handleChange_second.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='card'>
                <div className='card-header'>
                  {language.LC().PERFORMANCE}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>
                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>

              {/*<div className="col-sm-12 text-center margin_bottom_30">
 <button className="btn btn-primary" onClick={this._getall}>{this.state.more_detail_button}</button>
 </div>*/}
              <div className={this.state.show_outer} id='outer_readings_id'>
                {/*reading_data*/}
              </div>

              {/* ----------------------- Flashcard ------------- */}

              {/* <div className='padding_bottom_30'>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_FLASHCARDS}</h1>

                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.flashcardTabToggle('1');
                      }}
                      className={activeTabFlashcards === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.flashcardTabToggle('2');
                      }}
                      className={activeTabFlashcards === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabFlashcards === '1'
                        ? flashcard_data
                        : this.state.activeTabFlashcards === '2'
                        ? notes_flashcard_data
                        : null}
                    </div>
                  </div>
                </div>
              </div> */}
              {/* ----------------------- Saved  ------------- */}

              <div className='padding_bottom_30'>
                {' '}
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
                </h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.savedTabToggle('1');
                      }}
                      className={activeTabSaved === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.savedTabToggle('2');
                      }}
                      className={activeTabSaved === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    <li
                      onClick={() => {
                        this.savedTabToggle('3');
                      }}
                      className={activeTabSaved === '3' ? 'active' : ''}
                    >
                      <span> Videos </span>
                    </li>
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSaved === '1'
                        ? savedquestion_data
                        : this.state.activeTabSaved === '2'
                          ? savednotes_data
                          : this.state.activeTabSaved === '3'
                            ? savedVideoDataDisplay
                            : null}
                    </div>
                  </div>
                </div>
              </div>
              {/* ----------------------- Reports ------------- */}

              <div>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_REPORTS}</h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('1');
                      }}
                      className={activeTabReports === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('2');
                      }}
                      className={activeTabReports === '2' ? 'active' : ''}
                    >
                      <span> {language.LC().Notes} </span>
                    </li>
                    <li
                      onClick={() => {
                        this.reportsTabToggle('3');
                      }}
                      className={activeTabReports === '3' ? 'active' : ''}
                    >
                      <span> Videos </span>
                    </li>
                  </ul>
                </div>

                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabReports === '1'
                        ? question_reportsData
                        : this.state.activeTabReports === '2'
                          ? notes_reportsData
                          : this.state.activeTabReports === '3'
                            ? reportedVideosDataDisplay
                            : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-4'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUESTION_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='1'
                      id='1'
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {qpLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.questionProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>

              <div className='card'>
                <div className='card-header'>
                  {language.LC().NOTES_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='2'
                      id='2'
                      content={this.state.tooltips[2].placement}
                      place_tip={this.state.tooltips[2].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {npLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.notesProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlert}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.toggleClose}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.toggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

var bar_data_sub = [];
var reading_text = '';
function Barget(props) {
  if (props.subreadings_status && props.endDate !== '') {
    var data = {
      idname: props.idname,
      chapter_id: props.chapter_id,
      token: props.token,
      startDate: props.startDate,
      endDate: props.endDate,
    };
  } else {
    var data = {
      idname: props.idname,
      chapter_id: props.chapter_id,
      token: props.token,
      startDate: '',
      endDate: '',
    };
  }

  FD.callAPI(App_data.backend_api + '/soa_p_dashboard/subProgressbar', data).then(resp => {
    FD.callAPI(App_data.backend_api + '/soa_p_dashboard/subProgressbarofclass', data).then(
      resp_class => {
        /*class variable */
        var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
        var dataReason_class = JSON.parse(dataString_class);
        var final_array_main_class = [];

        for (iterator = 0; iterator < dataReason_class.length; iterator++) {
          var right_answered_class = dataReason_class[iterator].right_answer;
          var total_question_class = dataReason_class[iterator].total_questions;
          var user_graph_val_class = ((right_answered_class / total_question_class) * 100).toFixed(
            2,
          );
          final_array_main_class.push(user_graph_val_class);
        }
        // console.log('abc------------------'+final_array_main_class+'-------ssss--------');
        /*user variable*/
        var dataString = JSON.stringify(resp.readingwisebar_ret);
        var dataReason = JSON.parse(dataString);
        var final_array_main = [];
        var reading_text = [];

        for (iterator = 0; iterator < dataReason.length; iterator++) {
          var right_answered = dataReason[iterator].right_answer;
          var total_question = dataReason[iterator].total_questions;
          var user_graph_val = ((right_answered / total_question) * 100).toFixed(2);

          final_array_main.push(user_graph_val);
          reading_text.push(dataReason[iterator].reading.substring(0, 14));
        }

        bar_data_sub[props.answered_state] = {
          labels: reading_text,
          datasets: [
            {
              label: 'You',
              backgroundColor: 'rgb(114,195,250)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgb(114,195,250)',
              data: final_array_main,
            },
            {
              label: 'Class',
              backgroundColor: 'rgb(42,63,84)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgb(42,63,84)',
              data: final_array_main_class,
            },
          ],
        };
      },
    );
  });
  return <Bar data={bar_data_sub[props.answered_state]} options={{ maintainAspectRatio: false }} />;
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
        />
        {/*<i className="fa fa-info-circle" id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default SOA_P_Dashboard;


// WEBPACK FOOTER //
// ./src/views/SOA/Probability/Dashboard/Dashboard.js